import { defineMessages } from './messages';

/**
 * Shared translatable strings used across multiple components.
 * Import these from any component that needs common labels.
 */
export const CommonMessages = defineMessages({
  APP_NAME: {
    id: 'common.app_name',
    text: 'Localingos',
    description: 'Application name used across the UI',
  },
  SIGN_IN: {
    id: 'common.sign_in',
    text: 'Sign in/Sign up',
    description: 'Sign in/up action text',
  },
  SIGN_OUT: {
    id: 'common.sign_out',
    text: 'Sign out',
    description: 'Sign out action text',
  },
  PRIVACY_POLICY: {
    id: 'common.privacy_policy',
    text: 'Privacy Policy',
    description: 'Link text for the privacy policy page',
  },
  NO_LOCALES: {
    id: 'common.no_locales',
    text: 'No locales',
    description: 'Shown when a project has no target locales configured',
  },
  UNNAMED: {
    id: 'common.unnamed',
    text: '(Unnamed)',
    description: 'Fallback label for items without a name',
  },
  DISMISS_BANNER_ARIA: {
    id: 'common.dismiss_banner_aria',
    text: 'Dismiss banner',
    description: 'Aria label for the dismiss button on banners',
  },
  NEXT: {
    id: 'common.next',
    text: 'Next',
    description: 'Generic next button label',
  },
  TARGET_LOCALES_COUNT: {
    id: 'common.target_locales_count',
    text: '{{count}} target locale(s)',
    description: 'Shows the number of target locales for a project. {{count}} is the number',
  },
  BREADCRUMB_HOME: {
    id: 'common.breadcrumb_home',
    text: 'Home',
    description:
      'First crumb of the breadcrumb trail published as schema.org BreadcrumbList structured data on every marketing page. Names the site root, not a "Home" heading on the page. Shared because 15 pages emit the same first crumb.',
  },
});